export default __webpack_public_path__ + "static/media/benefit3.918ca952.svg";